import { render, staticRenderFns } from "./IconResourceInfoBall.vue?vue&type=template&id=621fddf8&"
import script from "./IconResourceInfoBall.vue?vue&type=script&lang=js&"
export * from "./IconResourceInfoBall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports